import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import StockPortal from "@/pages/StockPortal";
import AdminPage from "@/pages/AdminPage";
import Catalogs from "@/pages/Catalogs";
import Instructions from "@/pages/Instructions";
import CoAdminPortal from "@/pages/CoAdminPortal";

function App() {
  return (
    <div className="App min-h-screen bg-[#0A0A0A] text-white">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<StockPortal />} />
          <Route path="/catalogs" element={<Catalogs />} />
          <Route path="/instructions" element={<Instructions />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/co-admin" element={<CoAdminPortal />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" theme="dark" />
    </div>
  );
}

export default App;
